import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { SMSTextService } from 'src/app/Service/SMSText/SMSText.service';

@Component({
  selector: 'app-SMSTextAdd',
  templateUrl: './SMSTextAdd.component.html',
  styleUrls: ['./SMSTextAdd.component.scss']
})
export class SMSTextAddComponent implements OnInit {

  Token:String=""

  constructor(
    private SMSText_Service:SMSTextService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.AddNewSMSText=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
      Dsc:new FormControl(null,Validators.required),
    })


    this.Nav_Service.CheckValidPage(this.Token,40).subscribe(
      data=>{

      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }


  //#region  Form Add

  AddNewSMSText:FormGroup;

  get_Form_Title(){
    return this.AddNewSMSText.get('Title') as FormControl;
  }

  get_Form_Dsc(){
    return this.AddNewSMSText.get('Dsc') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitAddNewSMSText(){
    var Record:General_Interface =Empty_General_Interface()
    Record.id=0
    Record.title=this.get_Form_Title().value
    Record.code=this.get_Form_Dsc().value
    this.InProccessing=true
    this.SMSText_Service.AddSMS_Text(Record,this.Token).subscribe(
      data=>{
        this.InProccessing=false
        if(data.id==-2){
          this.Alertify_Service.ErrorMessage("The entered title already exists in the list.")
        }
        else{
          this.AddNewSMSText.reset()
          this.Alertify_Service.SuccessMessage("Information saved successfully.")
        }
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }



}
